import React from 'react'

export const ExchangeSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M4.31587 9.2217L2.14453 7.05469'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
        fill='currentColor'
      />
      <path
        d='M4.31592 1.86719V9.22034'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
        fill='currentColor'
      />
      <path
        d='M6.90283 1.86719L9.07418 4.0342'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
        fill='currentColor'
      />
      <path
        d='M6.90283 9.22034V1.86719'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
        fill='currentColor'
      />
    </svg>
  )
}
